import { createSelector } from 'reselect';
import { RootState, PatientManagementState } from 'data';

// Define select dashboards  selectors
const patientManagementSelector = (state: RootState) => state.patientManagement;
/**
 * Helper function to create memoized selectors for different fields
 * @param field - The specific field of the dashboard  state to select
 * @returns A memoized selector for the specified field
 */

/**
 * Generic field selector
 */
const createDashboardSelector = <T extends keyof PatientManagementState>(field: T) =>
  createSelector(
    [patientManagementSelector],
    (patientManagementState): PatientManagementState[T] => patientManagementState[field]
  );

// Patients List
export const selectPatientsList = createDashboardSelector('patientsList');
export const selectedSearchQuery = createSelector(
  [selectPatientsList],
  (state) => state.searchQuery
);
